import { render, staticRenderFns } from "./QueueTweetCard.vue?vue&type=template&id=0a659072&scoped=true&"
import script from "./QueueTweetCard.vue?vue&type=script&lang=js&"
export * from "./QueueTweetCard.vue?vue&type=script&lang=js&"
import style0 from "./QueueTweetCard.vue?vue&type=style&index=0&id=0a659072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a659072",
  null
  
)

export default component.exports